/**
 * Single prop for empty / placeholder UI copy. No component-level hardcoded fallbacks:
 * merchants set `emptyStateMessage` (or legacy keys) via schema / template defaults.
 */
export function resolveEmptyStateMessage(
    props: Record<string, unknown>,
    ...legacyKeys: string[]
): string {
    const primary = props.emptyStateMessage;
    if (typeof primary === "string" && primary.trim()) return primary.trim();
    for (const k of legacyKeys) {
        const v = props[k];
        if (typeof v === "string" && v.trim()) return v.trim();
    }
    return "";
}
